let filesApi = {
    async get(type, id, token, companyId, params={}){
        let response = await window.axios.get('/api/files', {
            params:{
                api_token:token,
                company_logged:companyId,
                fileable_type:type,
                fileable_id:id,
                ...params
            }
        });
        return response.data;
    },
}

export default filesApi